import { BedroomIcon } from '../../icons/bedroom';
import { BathroomIcon } from '../../icons/bathroom';
import { GarageIcon } from '../../icons/garage';
import { ParkingIcon } from '../../icons/parking';
import { FloorSizeIcon } from '../../icons/floor-size';
import { LandSizeIcon } from '../../icons/land-size';

export function Features({
  bedrooms,
  bathrooms,
  garages,
  openParking,
  coveredParking,
  floorSize,
  landSize,
  withLabels=false,
}) {
  if (!bedrooms && !bathrooms && !garages && !openParking && !coveredParking && !floorSize && !landSize) {
    return null;
  }

  return (
    <div className={`property-card__features`}>
      {bedrooms && (
        <div className={`property-card__feature`}>
          <div className={`property-card__feature-icon`}><BedroomIcon /></div>
          <div className={`property-card__feature-value`}>{bedrooms}</div>
          {withLabels && <div className={`property-card__feature-label`}>Bedrooms</div>}
        </div>
      )}

      {bathrooms && (
        <div className={`property-card__feature`}>
          <div className={`property-card__feature-icon`}><BathroomIcon /></div>
          <div className={`property-card__feature-value`}>{bathrooms}</div>
          {withLabels && <div className={`property-card__feature-label`}>Bathrooms</div>}
        </div>
      )}

      {garages && (
        <div className={`property-card__feature`}>
          <div className={`property-card__feature-icon`}><GarageIcon /></div>
          <div className={`property-card__feature-value`}>{garages}</div>
          {withLabels && <div className={`property-card__feature-label`}>Garages</div>}
        </div>
      )}

      {(openParking || coveredParking) && (
        <div className={`property-card__feature`}>
          <div className={`property-card__feature-icon`}><ParkingIcon /></div>
          <div className={`property-card__feature-value`}>{openParking || 0 + coveredParking || 0}</div>
          {withLabels && <div className={`property-card__feature-label`}>Parking</div>}
        </div>
      )}

      {floorSize && (
        <div className={`property-card__feature`}>
          <div className={`property-card__feature-icon`}><FloorSizeIcon /></div>
          <div className={`property-card__feature-value`}>{floorSize}</div>
          {withLabels && <div className={`property-card__feature-label`}>Floor Size</div>}
        </div>
      )}

      {landSize && (
        <div className={`property-card__feature`}>
          <div className={`property-card__feature-icon`}><LandSizeIcon /></div>
          <div className={`property-card__feature-value`}>{landSize}</div>
          {withLabels && <div className={`property-card__feature-label`}>Land Size</div>}
        </div>
      )}
    </div>
  );
}
